import * as React from 'react'
import { styled } from '$utils/theme'
import { rem } from 'polished'

export interface Props extends React.InputHTMLAttributes<any> {
  className?: string
  isChecked?: (name: string) => boolean
  block?: boolean
}

const StyledLabel = styled.span.attrs({})<Props>`
  cursor: ${p => (p.block ? 'default' : 'pointer')};
  display: flex;
  top: 0;
  border-radius: ${rem(20)};
  height: ${p => rem(p.theme.sizes.small)};
  -webkit-transition: 0.4s;
  transition: 0.4s;
`
const SwitchInput = styled.input.attrs({})<Props>`
  position: absolute;
  opacity: 0;
  top: 0;

  &:focus {
    outline: none;
  }

  ~ ${StyledLabel} {
    width: ${p => rem(p.theme.sizes.large)};
    &::after {
      display: flex;
      position: absolute;
      top: -1px;
      content: '';
      height: ${p => rem(p.theme.sizes.small)};
      border-radius: 100%;
      width: ${p => rem(p.theme.sizes.small)};
      background-color: ${p => p.theme.colors.white};
      border: solid 0.5px ${p => p.theme.colors.lightGrey};
      cursor: ${p => (p.block ? 'default' : 'pointer')};
      -webkit-transition: 0.4s;
      transition: 0.4s;
    }
  }
  &:checked ~ ${StyledLabel} {
    background-color: ${p => p.theme.colors.blue};
    width: ${p => rem(p.theme.sizes.large)};
    border-radius: ${rem(20)};
    &::after {
      top: 0px;
      border-radius: 100%;
      background-color: ${p => p.theme.colors.white};
      border: solid 0.5px ${p => p.theme.colors.blue};
      animation: slide 0.5s forwards;
      -webkit-animation: slide 0.5s forwards;
      animation-delay: 2s;
      -webkit-transform: translateX(26px);
      -ms-transform: translateX(26px);
      transform: translateX(26px);
    }
  }
`
const SwitchWrapper = styled.label.attrs({})<Props>`
  display: block;
  float: right;
  position: relative;
  border: solid 1px ${p => p.theme.colors.lightGrey};
  background-color: ${p => p.theme.colors.lightGrey};
  border-radius: ${rem(20)};
  height: ${p => rem(p.theme.sizes.small)};
  width: ${p => rem(p.theme.sizes.large)};
  ${p =>
    p.block &&
    `
    opacity: 0.3;
  `}

  > ${SwitchInput}:checked {
    background-color: ${p => p.theme.colors.blue};
  }
`

export const Switch: React.SFC<Props> = ({ name, onBlur, isChecked, block, ...props }) => {
  return (
    <SwitchWrapper block={block}>
      <SwitchInput
        name={name}
        onBlur={onBlur}
        defaultChecked={isChecked(name)}
        type="checkbox"
        block={block}
        data-testid="checkbox"
        {...props}
      />
      <StyledLabel block={block} />
    </SwitchWrapper>
  )
}



// WEBPACK FOOTER //
// ./src/views/components/Switch/Switch.tsx